export default "__VITE_ASSET__QMgctO8r__"